import React from 'react';
import { FormAsyncMultiSelect } from '@getro/rombo';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';

import { FormikAutoSubmit } from '../../../../../atoms/formikAutoSubmit';
import { FormExtraOptions } from '../../../../../molecules/formExtraOptions';
import { useLocationFilter } from './useLocationFilter';

export const LocationFilter = ({ value = [], setFilters, locationRadius }) => {
  const { formSchema, locationRadiusOptions, onSearchChange, onSubmit } = useLocationFilter({ setFilters });

  return (
    <Formik
      initialValues={{ locationIds: value || [], locationRadius }}
      validationSchema={formSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      {({ values }) => {
        const showRadius = values.locationIds?.some((item) => item.type === 'locality');

        return (
          <Form>
            <FormikAutoSubmit />
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <Field
                name="locationIds"
                placeholder="Search"
                size="small"
                component={FormAsyncMultiSelect}
                loadOptions={onSearchChange}
                anchorToBody
                aria-label="Search locations"
              />
              {showRadius && (
                <Field
                  name="locationRadius"
                  placeholder="Any"
                  size="small"
                  component={FormExtraOptions}
                  options={locationRadiusOptions}
                  anchorToBody
                  aria-label="Location radius"
                />
              )}
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

LocationFilter.propTypes = {
  value: PropTypes.array,
  setFilters: PropTypes.func.isRequired,
  locationRadius: PropTypes.object,
};

LocationFilter.defaultProps = {
  value: [],
  locationRadius: { label: 'Within 10 miles (16km)', value: 10 },
};
